import React from 'react';
import classnames from 'classnames';
import styles from './icons.scss';

const SvgClose = (props) => (
  <svg
    {...props}
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classnames(styles.icon, props.className)}
  >
    <path
      d="M5 5L19 19M5 19L19 5"
      stroke="#959CA4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round" />
  </svg>
);

export default React.memo(SvgClose);
